module.exports = __webpack_public_path__ + "assets/img/data-null.8c4b0c02.png";